import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { AgentFindInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-find.dto';
import type { AgentItemsPageInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-items-page.dto';
import type { AgentPageInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-page.dto';
import type { AgentQueryInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiAgentService extends BaseService {
  protected baseUrl = '/ai/agent';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: AgentQueryInterface): Observable<AgentItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<AgentItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findWithPagination(queryParams: AgentQueryInterface): Observable<AgentPageInterface> {
    return this.http.get<AgentPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<AgentFindInterface> {
    return this.http.post<AgentFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
